import React, { useState, useEffect } from 'react'
import { Navbar, Nav, Container, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import clsx from 'clsx'

import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'

// assets
import FotoProfile from 'landing-page/assets/img/user-profile.png'

interface HeaderProps {
  className?: string
  logo?: string
  menuItems?: Array<{
    label: string
    href: string
    external?: boolean
  }>
  ctaButton?: {
    label: string
    href: string
    variant?: string
  }
  user?: any
}

const Header: React.FC<HeaderProps> = ({
  className,
  logo,
  menuItems = [],
  ctaButton = null,
  user,
}) => {

  const navigate = useNavigate()

  const [isScrolled, setIsScrolled] = useState(false);

  const [collapseShow, setCollapseShow] = useState(false)

  const [activeButton, setaAtiveButton] = useState('register')

  const toggleCollapse = () => {
    setCollapseShow(!collapseShow)
  }

  const clickButton = () => {
    setaAtiveButton(activeButton == 'login' ? 'register' : 'login')
  }

  const handleLogout = () => {
    clearLocalStorageExcept([])

    // navigate to home page  
    navigate('/')
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={clsx(
        'header bg-white',
        isScrolled && 'header-scrolled bg-white',
        className
      )}
    >
      <Container>
        <Link to="/" className="fw-bold d-flex align-items-center navbar-brand">
          <img width={200} height={35} src={logo} alt="Logo LPDP Talenta" />
        </Link>
        
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {menuItems.map((item, index) => (
              <Nav.Link
                key={index}
                href={item.href}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
          
          {ctaButton && (
            <Button
              href={ctaButton.href}
              variant={ctaButton.variant}
              className="ms-lg-3"
            >
              {ctaButton.label}
            </Button>
          )}

          {user ? (
              <div className="col-md-6" style={{ textAlign: 'right' }}>
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                      <img
                          src={user?.detail?.user_details_photo ? user?.detail?.user_details_photo : FotoProfile}
                          width={35}
                          height={35}
                          className="rounded-circle"
                          alt="Profile Image" />

                      <div className="dropdown">
                          <button
                              className="btn btn-sm btn-primary-outline dropdown-toggle"
                              id="dropdownProfile"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {user?.fullname || `${user?.users_firstname || ''} ${user?.users_lastname || ''}`.trim() || 'User'}
                          </button>

                          <ul className="dropdown-menu" aria-labelledby="dropdownProfile">
                              <li>
                                  <Link
                                      onClick={() => clickButton()}
                                      className={`btn btn-sm rounded-pill`}
                                      to={'/profile-user'}>Profile</Link>
                              </li>
                              <li>
                                  <Link
                                      className={`btn btn-sm rounded-pill`}
                                      to={'/riwayat-pengajuan'}>Riwayat Pengajuan</Link>
                              </li>
                              <li>
                                  <button
                                      type='button'
                                      className={`btn btn-sm rounded-pill`}
                                      onClick={() => handleLogout()}>Logout</button>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
            ) : null}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;